import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import ImgTag from "../Helpers/ImgTag";
import { validateImgSrc } from "@/utils/global";

function FreeProduct({ items }) {
  const [totalPrice, setTotalPrice] = useState();
  const { locale } = useRouter();
  let totalPriceCalc = 0;
  useEffect(() => {
    if (items) {
      if (items.length == 1) {
        let number = items[0]?.product_special_price
          ? items[0]?.product_special_price
          : items[0]?.product_price;
        number = parseFloat(number).toFixed(2);
        setTotalPrice(number);
      } else {
        items?.forEach((item) => {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          totalPriceCalc += item.product_special_price
            ? +item.product_special_price
            : +item.product_price;
        });
        setTotalPrice(totalPriceCalc);
      }
    }
  }, [items]);

  function truncateToTwoDecimalPlaces(number) {
    const formattedNumber = Number(number?.toFixed(2));
    return formattedNumber.toFixed(2);
  }
  return (
    <div className="free-product-component border my-[1rem] rounded-[10px] p-[1rem] pb-[0rem] bg-white">
      <div className="head flex justify-start items-center">
        <ImgTag
          src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=60&h=60,fit=contain,format=auto,quality=75/gift.webp`}
          className="w-auto h-auto"
          width={200}
          height={200}
          alt="Gift Icon"
          sizes="(max-width:768px) 100vw, (max-width:1200px) 50vw, 33vw"
          loading="eager"
        />

        {totalPrice &&
          (locale == "ar" ? (
            <h4 className="text-[#1C278F] text-[28px] ms-[10px]">
              هدية (هدايا) مجانية بقيمة{" "}
              {truncateToTwoDecimalPlaces(+totalPrice)} ر.س.
              <span className="text-[#50555E] text-[18px] ms-[10px]">
                (سيتم إضافة المنتج في السلة بشكل تلقائي)
              </span>
            </h4>
          ) : (
            <h4 className="text-[#1C278F] text-[28px] ms-[10px]">
              Free gifts with {truncateToTwoDecimalPlaces(+totalPrice)} SR
              <span className="text-[#50555E] text-[18px] ms-[10px]">
                (The product will be added to the cart automatically.)
              </span>
            </h4>
          ))}
      </div>
      <div className="lower flex justify-start items-center mt-[2rem] overflow-x-auto container-of-scroll-gifts-pdp">
        {items.map((item, index) => {
          return (
            <>
              <FreeProductItem key={index} item={item} locale={locale} />
            </>
          );
        })}
      </div>
    </div>
  );
}

export default FreeProduct;

export function FreeProductItem({ item, locale }) {
  function truncateToTwoDecimalPlaces(number) {
    const formattedNumber = Number(number?.toFixed(2));
    return formattedNumber.toFixed(2);
  }

  return (
    <div className="item-cont min-w-[42%] flex items-center justify-start min-h-[160px] border me-[4rem] p-[1rem] mb-[1rem] rounded-[10px]">
      <div className="img-cont">
        <ImgTag
          src={validateImgSrc(
            `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/catalog/product/${item.product_image}`
          )}
          className="w-[120px] h-[120px] rounded-[4px]"
          width={80}
          height={80}
          alt="item Icon"
        />
      </div>
      <div className="info-part flex flex-col items-start justify-start ms-[1rem] min-h-[110px]">
        <h6 className="text-[#353534] text-[14px]">
          {locale == "ar"
            ? item?.product_name_ar
              ? item?.product_name_ar
              : item?.product_name
            : item?.product_name}
        </h6>
        <h3 className="text-[#D9232E] text-[20px] mt-[10px]">
          {item.product_special_price
            ? truncateToTwoDecimalPlaces(+item.product_special_price)
            : truncateToTwoDecimalPlaces(+item.product_price)}{" "}
          ر.س.
        </h3>
      </div>
    </div>
  );
}
